var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCandidates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 99,
    viewBox: "0 0 105 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4383_15243)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 49.5361,
    height: 49.5361,
    rx: 7.86288,
    fill: "#2C7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0591 38.0452C49.0591 35.892 47.3136 34.1465 45.1604 34.1465C43.0072 34.1465 41.2617 35.892 41.2617 38.0452C41.2617 40.1983 43.0072 41.9438 45.1604 41.9438C47.3136 41.9438 49.0591 40.1983 49.0591 38.0452Z",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0392 38.4348C49.3979 38.5436 49.7783 38.602 50.1724 38.602C52.3256 38.602 54.0711 36.8565 54.0711 34.7034C54.0711 32.5502 52.3256 30.8047 50.1724 30.8047C48.1507 30.8047 46.4885 32.3434 46.293 34.3136",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0281 34.3136C43.8326 32.3434 42.1703 30.8047 40.1487 30.8047C37.9955 30.8047 36.25 32.5502 36.25 34.7034C36.25 36.8565 37.9955 38.602 40.1487 38.602C40.5428 38.602 40.9232 38.5436 41.2818 38.4348",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2984 44.1731C56.2984 41.0971 53.5555 38.6035 50.1719 38.6035",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2881 47.5149C51.2881 44.4389 48.5453 41.9453 45.1616 41.9453C41.7781 41.9453 39.0352 44.4389 39.0352 47.5149",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.146 38.6035C36.7625 38.6035 34.0195 41.0971 34.0195 44.1731",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4383_15243",
    x: -14.5967,
    y: -20.5967,
    width: 118.728,
    height: 118.728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2983
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4383_15243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4383_15243",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCandidates);
export default __webpack_public_path__ + "static/media/ActiveCandidates.9897033d618028ec2abe98039ede8378.svg";
export { ForwardRef as ReactComponent };